// extracted by mini-css-extract-plugin
export default {"hero":"Hero1_hero__fVDEv","images":"Hero1_images__enbRL","image":"Hero1_image__nWDfh","textOverlay":"Hero1_textOverlay__MTsnC","title":"Hero1_title__RON5s"};